export default [
  {
    nodeTypeId: 'TrustedFormIVRNode',
    nodeOptions: {
      accentColor: '#856607',
      icon: 'fa fa-shield'
    }
  },
  {
    nodeTypeId: 'BlacklistBLANode',
    nodeOptions: {
      accentColor: '#856607',
      icon: 'fa fa-shield'
    }
  },
  {
    nodeTypeId: 'JornayaTCPANode',
    nodeOptions: {
      accentColor: '#856607',
      icon: 'fa fa-shield'
    }
  },
  {
    nodeTypeId: 'JSNode',
    nodeOptions: {
      accentColor: '#F1C40F',
      icon: 'fa fa-code'
    }
  },
  {
    nodeTypeId: 'BlacklistNode',
    nodeOptions: {
      accentColor: '#856607',
      icon: 'fa fa-shield'
    }
  },
  {
    nodeTypeId: 'EnrichNode',
    isPopular: true,
    nodeOptions: {
      accentColor: '#2471A3',
      icon: 'fa fa-user'
    }
  },
  {
    nodeTypeId: 'HoursOfOperationNode',
    nodeOptions: {
      accentColor: '#9AC8D5',
      icon: 'fa fa-clock-o'
    }
  },
  {
    nodeTypeId: 'PixelNode',
    nodeOptions: {
      accentColor: '#9AC8D5',
    }
  },
  {
    nodeTypeId: 'DialNode',
    isPopular: true,
    nodeOptions: {
      accentColor: '#52BE80',
      icon: 'fa fa-phone'
    }
  },
  {
    nodeTypeId: 'GatherNode',
    nodeOptions: {
      accentColor: '#838685',
    }
  },
  {
    nodeTypeId: 'GoToNode',
    nodeOptions: {
      accentColor: '#838685',
      icon: 'fa fa-reply'
    }
  },
  {
    nodeTypeId: 'HangupNode',
    isPopular: true,
    nodeOptions: {
      accentColor: '#E67E22',
      size: 'small',
      icon: 'fa fa-phone fa-rotate-180'
    }
  },
  {
    nodeTypeId: 'MenuNode',
    isPopular: true,
    nodeOptions: {
      accentColor: '#2471A3',
      icon: 'fa fa-bars'
    }
  },
  {
    nodeTypeId: 'PlayNode',
    nodeOptions: {
      accentColor: '#884EA0',
      icon: 'fa fa-volume-up'
    }
  },
  {
    nodeTypeId: 'RecordNode',
    nodeOptions: {
      accentColor: '#884EA0',
      icon: 'fa fa-volume-up'
    }
  },
  {
    nodeTypeId: 'RouterNode',
    isPopular: true,
    nodeOptions: {
      accentColor: '#838685',
      size: 'medium',
      icon: 'fa fa-code-fork fa-rotate-90'
    },
  },
  {
    nodeTypeId: 'SplitTestNode',
    isPopular: false,
    nodeOptions: {
      accentColor: '#838685',
      size: 'medium',
      icon: 'fa fa-random p-t-5'
    }
  }
];